import React from 'react'
import MobileMenu from '../mobileMenu/index'
import logo from '../../static/logo.png'
import './_header.scss'

const Menu = () => (
  <ul className="animated fadeInRight">
  <li> <a href="http://cetraruddy.com/expertise" target="_blank" rel="noopener">Studio</a></li>
  <li> <a href="http://cetraruddy.com/projects" target="_blank" rel="noopener">Projects</a></li>
  <li> <a href="/" target="_blank" rel="noopener" className="yellow">CR Celebrates</a></li>
  <li> <a href="http://cetraruddy.com/media" target="_blank" rel="noopener">Media</a></li>
  <li> <a href="http://cetraruddy.com/location" target="_blank" rel="noopener">Contact</a></li>
</ul>
)
const mq = window.matchMedia( "(max-width: 768px)" )
const checkMobile = () => (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1) || mq.matches
const conditionalMenu = checkMobile() ? <MobileMenu /> : <Menu />

const Header = () => (
  <header className="header">
    <nav className="site_nav">
      <div className="logo animated fadeInLeft">
        <a href="http://cetraruddy.com">
        <img src={logo} alt="CetraRuddy Logo" />
        </a>
      </div>
      {conditionalMenu}
    </nav>
  </header>
)
export default Header



// WEBPACK FOOTER //
// ./src/components/header/index.js